import { searchRoutes } from "../../../constants";
import { getRow } from '../../../market-share/helpers/propertyInfoDetail';
import { indicatorsSettingsByKeyName, terms } from "../constants";
import { agentProductionTerms as apt } from '../../../constants';
import { getBusinessAddress } from '../../components/agentProfile/tabs/helpers/propertyInfoDetail';

export const getIsOfficeListBreakdown = (location) => location === searchRoutes.officeListBreakdown;

export const getSearchDescriptionTitle = (indicators, selectedOfficeListSearch) => {
    const agentsGained = indicators.find(i => i?.key === indicatorsSettingsByKeyName.otherAgentsGained.id)?.value;
    const agentsLost = indicators.find(i => i?.key === indicatorsSettingsByKeyName.otherAgentsLost.id)?.value;
    if (isNaN(agentsGained) || isNaN(agentsLost)) return '';
    const agentsDiff = agentsGained - agentsLost;
    const officeTitle = !!selectedOfficeListSearch ? selectedOfficeListSearch?.name : terms.selectedOfficeOrOffices;
    if (agentsDiff === 0) return terms.getZeroAgents(officeTitle);
    if (agentsDiff < 0) return terms.getShrunkByAgents(officeTitle, agentsDiff * -1);
    return terms.getGrewByAgents(officeTitle, agentsDiff);
};

export const buildOfficeDetails = (officeDetails) => {

    const rows = [];

    rows.push(getRow(apt.brokerID, officeDetails.brokerId));
    rows.push(getRow(apt.officeId, officeDetails.officeId));
    rows.push(getRow(apt.mls, officeDetails.mls));
    rows.push(getRow(apt.responsibleMember, officeDetails.responsibleMember));
    rows.push(getRow(apt.mlsIDs, officeDetails.totalAgents));
    rows.push(getRow(apt.producingAgents, officeDetails.producingAgents));
    rows.push(getRow(apt.officeName, officeDetails.officeName));
    rows.push(getRow(apt.emailAddress, officeDetails.emailAddress));
    rows.push(getRow(apt.memberType, officeDetails.memberType));
    rows.push(getRow(apt.status, officeDetails.status));
    rows.push(getRow(apt.businessAddress, getBusinessAddress(officeDetails)));
    rows.push(getRow(apt.businessPhone, officeDetails.phoneList?.[0].phoneNumber));

    rows[rows.length - 1].isLastRow = true;

    return rows;
};
